/* react-router helpers */

import * as React from 'react';
import * as _ from 'lodash';
import { Redirect, Route } from 'react-router-dom';

import Auth from '../auth/auth';
import { Formatters } from '../common/formatters';
import { NavigationLinks } from '../common/navigation';
import { AuthConfig } from '../config/authconfiguration';

const RenderMergedProps = (component, ...rest) => {
    // Render a component with merged properties
    const finalProps = Object.assign({}, ...rest);

    return (
        React.createElement(component, finalProps)
    );
};

export const AuthorizedRoute = (props: any) => {
    // Defines a Route entry which can only be accessed by users with a valid auth session
    const { component, requiresRegionalComponentListAccess = false, ...rest } = props;

    const auth = new Auth();
    const redirectToAfterLogin = auth.getCurrentViewPath();

    const mergeAuthorizedRouteProps = {
        authed: auth.isAuthenticated(),
        authsession: auth.getSession(),
        authLoggedOut: auth.isLoggedOut(),
        authPasswordChangeRequired: auth.isPasswordChangeRequired(),
        authUserObjId: auth.getSessionUserObjectId(),
    };

    return (
        <Route
            {...rest}
            render={routeProps => {
                if (mergeAuthorizedRouteProps.authed) {
                    const passwordChangeRequired = Formatters.getBool(mergeAuthorizedRouteProps, `authsession.[${AuthConfig.ProfilePaths.userPasswordChangeRequired}]`);
                    // console.log(`auth render passwordChangeRequired ${passwordChangeRequired}`, { passwordChangeRequired, mergeAuthorizedRouteProps, routeProps });

                    if (passwordChangeRequired) {
                        const changePasswordUrl = NavigationLinks.userChangePassword(mergeAuthorizedRouteProps.authUserObjId);

                        return (
                            <Redirect
                                to={{
                                    pathname: changePasswordUrl,
                                    state: { from: routeProps.location }
                                }}
                            />);
                    }

                    if (requiresRegionalComponentListAccess && !auth.canAccessRegionalComponentLists()) {
                        return (
                            <Redirect
                                to={{
                                    pathname: NavigationLinks.userDashboard(),
                                    state: { from: routeProps.location }
                                }}
                            />
                        );
                    }

                    return RenderMergedProps(component, routeProps, mergeAuthorizedRouteProps, rest);
                } else {
                    if (mergeAuthorizedRouteProps.authLoggedOut) {
                        return (
                            <Redirect
                                to={{
                                    pathname: NavigationLinks.userLogout(),
                                    state: { from: routeProps.location }
                                }}
                            />);
                    }

                    const url = NavigationLinks.userLogin(redirectToAfterLogin);

                    return (
                        <Redirect
                            to={{
                                pathname: url,
                                state: { from: routeProps.location }
                            }}
                        />);
                }
            }}
        />
    );
};



// WEBPACK FOOTER //
// ./src/common/routing.tsx